export default class MentionsConstants {
  static readonly charactersAfterAtSignRegex = new RegExp(/@([a-zA-Z0-9 ]+)/);
}
